import script from "./avatarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./avatarView.vue?vue&type=script&setup=true&lang=ts"

import "./avatarView.vue?vue&type=style&index=0&id=6ddb3e1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ddb3e1c"]])

export default __exports__